import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../header/header2";
import { MdCategory } from "react-icons/md";
import { AiOutlineBarcode } from "react-icons/ai";
import { Breadcrumb } from "antd";
import axios from "../../utils/axios";

const ProjectCategories = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const citriot = JSON.parse(localStorage.getItem("citriot"));
  const [userSector, setUserSector] = useState("");
  const organizationId = localStorage.getItem("organizationId");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [userUseCases, setUserUseCases] = useState([]);
  const projectname =
    location.state?.projectname ||
    localStorage.getItem("projectname") ||
    "";

  if (location.state?.projectname) {
    localStorage.setItem("projectname", location.state.projectname);
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const username = citriot?.auth?.user;
        if (!username || !organizationId) return;

        const response = await axios.post("/fetch-user-data", {
          username,
          organizationId,
          projectname
        });

        if (response.data.success) {
          if (response.data.source === "project") {
            setUserSector(response.data.mainCategory || "");
          } else {
            setUserUseCases(response.data.useCases || []);
            setUserSector(response.data.sector || "");
          }
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const handleRedirect = (url, mainCategory) => {
    localStorage.setItem("mainCategory", mainCategory);
    const slug = mainCategory.replace(/\s*\/\s*/g, "-").replace(/\s+/g, "-");
    navigate(`/usecases/${slug}`, { state: { mainCategory } });
  };

  const moveToHome = () => {
    navigate("/create-project");
  };

  const cards = [
    {
      icon: <div className="text-white text-4xl drop-shadow-lg"><AiOutlineBarcode /></div>,
      label: "QSR / Fast Food",
      description: "Monitor staff productivity, food safety, queue times, and POS activities in restaurants",
      path: "/qsr",
      bg: "from-red-500 to-orange-600",
      lightBg: "from-red-50 to-orange-50",
      accentColor: "text-red-600",
    },
    {
      icon: <div className="text-white text-4xl drop-shadow-lg"><MdCategory /></div>,
      label: "Manufacturing",
      description: "Monitor PPE compliance, machine productivity, defects, and restricted zones",
      path: "/manufacturing",
      bg: "from-orange-500 to-amber-600",
      lightBg: "from-orange-50 to-amber-50",
      accentColor: "text-orange-600",
    },
    {
      icon: <div className="text-white text-4xl drop-shadow-lg"><AiOutlineBarcode /></div>,
      label: "Retail",
      description: "Analyze customer footfall, queue management, theft prevention, and store heatmaps",
      path: "/retail",
      bg: "from-violet-500 to-purple-600",
      lightBg: "from-violet-50 to-purple-50",
      accentColor: "text-violet-600",
    },
    // {
  //   icon: <div className="text-white text-4xl drop-shadow-lg"><MdConstruction /></div>,
  //   label: "Construction",
  //   description: "Ensure worker safety, monitor exclusion zones, and track construction progress",
  //   path: "/construction",
  //   bg: "from-yellow-500 to-orange-600",
  //   lightBg: "from-yellow-50 to-orange-50",
  //   accentColor: "text-yellow-600",
  // },
  // {
  //   icon: <div className="text-white text-4xl drop-shadow-lg"><FaHardHat /></div>,
  //   label: "Hospitality",
  //   description: "Monitor guest flow, housekeeping efficiency, kitchen safety, and hotel security",
  //   path: "/hospitality",
  //   bg: "from-blue-500 to-cyan-600",
  //   lightBg: "from-blue-50 to-cyan-50",
  //   accentColor: "text-blue-600",
  // }
  // {
  //   icon: <div className="text-white text-4xl drop-shadow-lg"><FaSchool /></div>,
  //   label: "Education",
  //   description: "Monitor student attendance, campus safety, unauthorized access, and crowd activity in schools and universities",
  //   path: "/education",
  //   bg: "from-indigo-500 to-blue-600",
  //   lightBg: "from-indigo-50 to-blue-50",
  //   accentColor: "text-indigo-600",
  // }
];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 font-sans">
      <Header auth={citriot?.auth} />
      <Breadcrumb
        className="text-base p-4 text-[#1A59A7] font-Ubuntu tracking-wider"
        items={[
          { title: <a onClick={moveToHome}>Projects</a> },
          { title: "Sectors" },
        ]}
      />
      <main className="md:p-6">
        <div className="w-full max-w-7xl">
          <div className="flex items-center mb-4">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 tracking-tight">
              Categories
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-8">
          {cards.map((card, index) => {
            // ✅ Check if this card's label exists in user's useCases
            const isMatched =
              userSector?.toLowerCase() === card.label.toLowerCase();

            return (
              <div
                key={index}
                onClick={() => handleRedirect(card.path, card.label)}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                className="group cursor-pointer relative"
              >
                {/* Shadow effect */}
                <div className="absolute -inset-1 bg-gradient-to-r from-gray-200 to-gray-300 rounded-3xl opacity-0 group-hover:opacity-100 transition-all duration-300 blur-sm shadow-md"></div>

                {/* Main card */}
                <div
                  className={`relative bg-white border-2 border-gray-100 rounded-3xl p-6 h-[20rem] flex flex-col justify-between 
                  transition-all duration-300 group-hover:scale-[1.02] group-hover:border-gray-200 group-hover:shadow-2xl shadow-md`}
                >
                  {/* Light gradient background on hover */}
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${card.lightBg} rounded-3xl opacity-0 group-hover:opacity-50 transition-opacity duration-300`}
                  ></div>

                  {/* ✅ Green checkmark badge — shown if matched */}
                  {isMatched && (
                    <div className="absolute top-4 right-4 z-10 w-7 h-7 rounded-full bg-green-500 flex items-center justify-center shadow-md">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  )}

                  {/* Top Section */}
                  <div className="relative flex flex-col flex-grow">
                    <div
                      className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${card.bg} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:shadow-xl transition-all duration-300`}
                    >
                      {card.icon}
                    </div>

                    <div className="space-y-3">
                      <h3 className={`text-xl font-bold text-gray-800 group-hover:${card.accentColor} transition-colors duration-300`}>
                        {card.label}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
                        {card.description}
                      </p>
                    </div>
                  </div>

                  {/* Hover arrow indicator */}
                  <div
                    className={`absolute bottom-6 right-6 w-8 h-8 rounded-full bg-gradient-to-r ${card.bg} flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 group-hover:translate-x-0 shadow-lg`}
                  >
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default ProjectCategories;